module.exports = __webpack_public_path__ + "static/media/pf_item_42.fad463c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_42.jpg
// module id = 170
// module chunks = 0